import {Component} from '@angular/core';
import {BaseErrorDetailComponent} from '../common/base-error-detail/base-error-detail.component';
import {ErrorMessage} from '../../models/error/ErrorMessage';
import {ErrorMessageService} from '../../services/error/error-message.service';
import {ErrorDetailTemplateComponent} from '../common/error-detail-template/error-detail-template.component';
import {IonContent} from '@ionic/angular/standalone';
import {ErrorDetailRuleComponent} from '../common/error-detail-rule/error-detail-rule.component';
import {CommonModule} from '@angular/common';
import {HeaderComponent} from '../common/header/header.component';

@Component({
    selector: 'app-error-message-detail',
    standalone: true,
    imports: [ErrorDetailTemplateComponent, IonContent, ErrorDetailRuleComponent, CommonModule, HeaderComponent],
    templateUrl: './error-message-detail.component.html',
    styleUrl: './error-message-detail.component.css'
})
export class ErrorMessageDetailComponent extends BaseErrorDetailComponent<ErrorMessage> {
    constructor(private errorMessageService: ErrorMessageService) {
        super(errorMessageService);
    }
}
